dmx.config.mapping['.view'] = 'f7-view';
dmx.config.mapping['.page'] = 'f7-page';
dmx.config.mapping['.popup'] = 'f7-popup';
dmx.config.mapping['.login-screen'] = 'f7-login-screen';
dmx.config.mapping['.actions-modal'] = 'f7-action-sheet';
dmx.config.mapping['.progressbar'] = 'f7-progressbar';
dmx.config.mapping['.toggle:not(.toggle-init)'] = 'f7-toggle';
dmx.config.mapping['.ptr-content'] = 'f7-ptr';
dmx.config.mapping['.accordion-item'] = 'f7-accordion';
dmx.config.mapping['.sheet-modal'] = 'f7-sheet-modal';